import {StateLabel} from '@primer/react'
import {graphql, useFragment} from 'react-relay'

import type {HeaderState_issue$key} from './__generated__/HeaderState_issue.graphql'
import {TEST_IDS} from '../../constants'

type HeaderStateProps = {
  stateData: HeaderState_issue$key
}

export function HeaderState({stateData}: HeaderStateProps) {
  const {state, stateReason} = useFragment(
    graphql`
      fragment HeaderState_issue on Issue {
        state
        stateReason
      }
    `,
    stateData,
  )
  return (
    <StateLabel data-testid={TEST_IDS.headerState} status={issueStateStatus(state, stateReason ?? '')}>
      {issueStateString(state)}
    </StateLabel>
  )
}

const issueStateStatus = (
  state: string,
  stateReason: string,
): 'issueOpened' | 'issueClosed' | 'issueClosedNotPlanned' => {
  switch (state) {
    case 'OPEN':
      return 'issueOpened'
    case 'CLOSED':
      return stateReason === 'NOT_PLANNED' ? 'issueClosedNotPlanned' : 'issueClosed'
    default:
      return 'issueClosed'
  }
}

const issueStateString = (state: string): string => {
  switch (state) {
    case 'OPEN':
      return 'Open'
    case 'CLOSED':
      return 'Closed'
    default:
      return ''
  }
}

try{ HeaderState.displayName ||= 'HeaderState' } catch {}